import apiURL from "./apiURL";
import { NotificationManager } from "react-notifications";
import { createRequest } from "@/helpers/RequestHelpers";

const request = createRequest({
	urlPath: "/settings/advisors",
});

const Types = {
	ADVISOR_TAX_FORM_LOAD_REPORTS: "ADVISOR_TAX_FORM_LOAD_REPORTS",
};

const advisorTaxFormGetReports = (reportType) => {
	return async (dispatch) => {
		await request({
			method: "GET",
			path: `/tax-forms/${reportType}`,
		})
			.then((response) => {
				dispatch(advisorTaxFormLoadReports(response.data));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Getting Tax Reports");
			});
	};
};

const advisorTaxFormLoadReports = (data) => ({
	type: Types.ADVISOR_TAX_FORM_LOAD_REPORTS,
	data,
});

const Actions = {
	advisorTaxFormGetReports,
	advisorTaxFormLoadReports,
};

export { Actions, Types };
